<template lang="pug">
  e-modal(
  v-if="!prefetch"
  @confirm="runOperation()"
  @close="$emit('close')"
  title="Перерасчет"
  saveBtnLabel="Выполнить"
  ref="modal"
  :autoHeight="true"
  ).house-move-recalc
    slot
      e-form(
        :formValidator="formValidator"
        form-class="fix-elements-overflow-problem"
        :enable-perfect-scrollbar="false"
      )
        div.body
          div.col
            e-form-group(
              label="Тип дома, старый"
              inputType="select"
              :model="fields"
              :tabView="tabView"
              name="old_house_type_id"
              :options="billingHouseType"
              :required="true"
              optionTextKey="adrhousetype"
              :disabled="true"
            )

            e-form-group(
              label="Тип дома, новый"
              inputType="select"
              :model="fields"
              :tabView="tabView"
              name="house_type_id"
              :options="billingHouseType"
              :required="true"
              optionTextKey="adrhousetype"
              @change="onHouseTypeChange()"
            )

            e-form-group(
              label="Параметр, старый"
              inputType="select"
              :model="fields"
              :tabView="tabView"
              name="branch_old"
              :options="parametersOld"
              :required="true"
            )

            e-form-group(
              label="Параметр, новый"
              inputType="select"
              :model="fields"
              :tabView="tabView"
              name="branch"
              :options="parameters"
              :required="true"
              @change="onBranchChange()"
            )

            e-form-group(
              label="Значение"
              name="value"
              :model="fields"
              :tabView="tabView"
              :disabled="true"
            )

          div.col
            e-form-group(
              label="Период"
              inputType="calendar-range"
              :model="fields"
              :tabView="tabView"
              name="start"
              toName="end"
              :valueFormat="CALENDAR.valueFormat"
              :format="CALENDAR.format"
              :required="true"
              type="date"
            )

            e-form-group(
              label="Операционный день"
              inputType="calendar"
              name="operation_date"
              :model="fields"
              :tabView="tabView"
              :required="true"
            )

</template>

<script>
  import FormValidator from '../../../components/form/form-validator'
  import {CALENDAR} from "../../../config/config"
  import {core, billing, wasteGenerators} from "../../../api/api-endpoints"
  import {OPERATION_RECACL_TYPE_NORMATIVE, BILL_HOUSE_TYPE_MKD, BILL_HOUSE_TYPE_INDIVIDUAL, NORMATIVE_TYPE_MKD, NORMATIVE_TYPE_INDIVIDUAL} from "../../../config/config"

  export default {
    name: "house-move-recalc",
    props: {
      model: {
        type: Object,
        default: () => ({})
      },
      normativeType: String
    },
    data() {
      return {
        prefetch: true,
        tabView: '',
        fields: {
          type: OPERATION_RECACL_TYPE_NORMATIVE,
          type_old: OPERATION_RECACL_TYPE_NORMATIVE,
          branch_old: '',
          branch: '',
          home_id: '',
          start: '',
          end: '',
          operation_date: '',
          old_house_type_id: '',
          house_type_id: '',
          value: ''
        }
      }
    },
    created() {
      this.formValidator = new FormValidator(this)
      this.fetchData()
    },
    computed: {
      parametersOld () {
        const houseTypeId = this.fields.old_house_type_id
        return this.getParameters(houseTypeId)
      },
      parameters () {
        const houseTypeId = this.fields.house_type_id
        return this.getParameters(houseTypeId)
      },
      CALENDAR () {
        return CALENDAR
      },
      billingHouseType () {
        return this.collection.billing_house_type
      },
      collection () {
        return this.$store.getters.readUrlEndpoint(
          this.getCollectionEndpoint()
        ) || {}
      },
      normativesIndividual () {
        return (this.$store.getters.readUrlEndpoint(
          this.getNormativesIndividualEndpoint()
        ) || {data: []}).data
      },
      normativesMKD () {
        return (this.$store.getters.readUrlEndpoint(
          this.getNormativesMKDEndpoint()
        ) || {data: []}).data
      }
    },
    methods: {
      onHouseTypeChange () {
        this.fields.branch = ''
        this.fields.value = ''
      },
      onBranchChange () {
        const selected = this.parameters.filter(v => v.id == this.fields.branch)[0]
        if (selected) {
          this.fields.value = selected.value || ''
        } else {
          this.fields.value = ''
        }
      },
      afterFetch () {
        this.fields.home_id = this.model.id
        this.fields.old_house_type_id = this.model.type_id
      },
      getCollectionEndpoint () {
        return core.collection('billing_house_type')
      },
      getNormativesMKDEndpoint () {
        return billing.normativeBranchs({
          query: {
            'per-page': -1
          }
        }, NORMATIVE_TYPE_MKD)
      },
      getNormativesIndividualEndpoint () {
        return billing.normativeBranchs({
          query: {
            'per-page': -1
          }
        }, NORMATIVE_TYPE_INDIVIDUAL)
      },
      async fetchData () {
        try {
          this.$bar.startOrContinue()

          this.prefetch = true
          await Promise.all([
            this.$store.dispatch('updateUrlEndpoint', {
              endpoint: this.getCollectionEndpoint(),
              fromCache: true,
              params: {
                disableGlobalError: true
              }
            }),
            this.$store.dispatch('updateUrlEndpoint', {
              endpoint: this.getNormativesMKDEndpoint(),
              params: {
                disableGlobalError: true
              }
            }),
            this.$store.dispatch('updateUrlEndpoint', {
              endpoint: this.getNormativesIndividualEndpoint(),
              params: {
                disableGlobalError: true
              }
            })
          ])
          this.afterFetch()
          this.prefetch = false
        } catch (e) {
          this.$e.errorBox(e)
          this.$emit('close')
        } finally {
          this.$bar.finish()
        }
      },
      getParameters (houseId) {
        const type = this.getHouseTypeById(houseId)
        if (type === BILL_HOUSE_TYPE_INDIVIDUAL) {
          return this.normativesIndividual
        }
        if (type === BILL_HOUSE_TYPE_MKD) {
          return this.normativesMKD
        }
        return []
      },
      /**
       * return type for use in src/app/waste-generators/mixins/waste-generators-form.js
       * typeRouteNameMap property
       * @param id
       * @returns {*}
       */
      getHouseTypeById (id) {
        let type = null
        this.billingHouseType.forEach(v => {
          if (v.id == id) {
            type = v.type
          }
        })
        return type
      },
      runOperation: async function () {
        if (!this.model.id) {
          this.$e.warningBox('Действие станет доступно после сохранеия')
          return
        }

        const {hasError} = this.formValidator.validate()
        if (hasError === true) {
          return
        }

        try {
          this.$bar.start()
          this.$refs.modal.freezeAll()

          await this.$store.dispatch('createModel', {
            url: wasteGenerators.recalcHomeMove(),
            data: this.fields
          })
          this.$e.successBox()

          const resolver = {
            resolve () {}
          }
          const waiter = new Promise(resolve => {
            resolver.resolve = resolve
          })
          this.$emit('updated', {
            fields: this.fields,
            oldType: this.getHouseTypeById(this.fields.old_house_type_id),
            newType: this.getHouseTypeById(this.fields.house_type_id),
            resolver
          })
          await waiter
          this.$emit('close')
        } catch (e) {
          if (e && +e.status === 422) {
            let {notFoundedErrorFieldsText} = this.formValidator.handleServerErrors(e, this)
            if (notFoundedErrorFieldsText) {
              this.$e.errorBox(
                'Некорректно заполнены поля',
                {text: notFoundedErrorFieldsText}
              )
            }
          } else {
            this.$e.errorBox(e)
          }
        } finally {
          this.$refs.modal && this.$refs.modal.unFreezeAll()
          this.$bar.finish()
        }

      }
    }
  }
</script>
